import CookieCheckbox from './Checkbox'

export default class CookieOptionsView {

    constructor(element, button, CookieBar) {
        this.element = element
        this.openButton = button
        this.CookieBar = CookieBar
        
        this.open = false

        const options = [...this.element.querySelectorAll('div.checkbox')]
        for (let i = 0; i < options.length; i++) {
            new CookieCheckbox(options[i], CookieBar)
        }

        this.openButton.addEventListener('click', this.onOpen.bind(this))
    }

    onOpen() {
        this.open = !this.open
        this.openButton.classList[this.open ? 'add' : 'remove']('active')
        
        this.CookieBar.acceptButton.hidden = this.open
        this.CookieBar.acceptSelectionButton.hidden = !this.open

        this.element.style.height = `${this.open ? this.element.scrollHeight : 0}px`
    }
}
